module.exports = __webpack_public_path__ + "img/joinStraight.3d686eac.svg";